import React from 'react'
import { useIntl } from 'react-intl'
import { ButtonBase, ButtonBaseProps } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import CaretDownIcon from '@src/icons/CaretDownIcon'
import messages from '@utils/messages'

const useStyles = makeStyles()((theme) => ({
  showMoreLess: {
    fontSize: theme.typography.pxToRem(14),
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightBold,
    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  icon: {
    width: 9,
    height: 5,
    marginLeft: theme.spacing(2),
  },
  iconExpanded: {
    transform: 'scaleY(-1)',
  },
}))

interface ShowMoreLessButtonProps extends ButtonBaseProps {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
  expandedText?: React.ReactNode
  collapsedText?: React.ReactNode
  onClick?: () => void
}

const ShowMoreLessButton: React.FC<ShowMoreLessButtonProps> = ({
  expanded,
  setExpanded,
  expandedText,
  collapsedText,
  className,
  onClick,
  ...buttonBaseProps
}) => {
  const { classes, cx } = useStyles()
  const { formatMessage } = useIntl()
  const handleClick = () => {
    setExpanded(!expanded)
    if (onClick) {
      onClick()
    }
  }
  return (
    <ButtonBase
      onClick={handleClick}
      aria-expanded={expanded}
      className={cx(classes.showMoreLess, className)}
      {...buttonBaseProps}
    >
      {!expanded ? (
        <>
          <span>{collapsedText || formatMessage(messages.SHOW_MORE)}</span>
          <CaretDownIcon className={classes.icon} />
        </>
      ) : (
        <>
          <span>{expandedText || formatMessage(messages.SHOW_LESS)}</span>
          <CaretDownIcon className={cx(classes.icon, classes.iconExpanded)} />
        </>
      )}
    </ButtonBase>
  )
}
export default ShowMoreLessButton
